function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "twitter_gradient",
  y1: 20.32,
  x2: 50,
  y2: 20.32,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#20c4f4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.17,
  stopColor: "#23bef2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#2daeed"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#3d92e5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.94,
  stopColor: "#536dd9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5963d6"
})));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Twitter");

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 40.63",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_19",
    "data-name": "Layer 19"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#twitter_gradient)"
    },
    d: "M50,4.81a20.48,20.48,0,0,1-5.89,1.62A10.29,10.29,0,0,0,48.62.75,20.42,20.42,0,0,1,42.1,3.24a10.26,10.26,0,0,0-17.74,7,10.69,10.69,0,0,0,.26,2.34A29.16,29.16,0,0,1,3.48,1.88,10.25,10.25,0,0,0,6.66,15.57,10.13,10.13,0,0,1,2,14.29v.13a10.26,10.26,0,0,0,8.23,10.06,10.49,10.49,0,0,1-2.71.36,10.27,10.27,0,0,1-1.93-.19,10.29,10.29,0,0,0,9.59,7.13A20.6,20.6,0,0,1,2.45,36.17,21.94,21.94,0,0,1,0,36a29,29,0,0,0,15.72,4.6c18.87,0,29.19-15.63,29.19-29.18,0-.45,0-.89,0-1.33A20.85,20.85,0,0,0,50,4.81Z"
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.a43d1b12.svg";
export { ForwardRef as ReactComponent };